import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Dimension } from '../../../model/api/administration/dimension';
import { GenericHttpService } from '../generic.http.service';
// import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class DimensionHttpService extends GenericHttpService<Dimension, number> {
    constructor(public http: HttpClient) {
        super(http, '', 'dimensions');
    }
}